import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useHistory} from 'src/rerouter/index';
import {
  ButtonTabs,
  ButtonTab,
} from '@spaced-out/ui-design-system/lib/components/index';


const TrackingTabs = () => {
  const {t} = useLabelTranslation();
  const history = useHistory();
  const {
    location: {pathname},
  } = history;

  let selectedTab = 'leads';

  if (pathname === '/referralv2/tracking/all-referrals') {
    selectedTab = 'all-referrals';
  }

  return (
    <ButtonTabs
      onButtonTabSelect={(value) =>
        history.push(`/referralv2/tracking/${value}`)
      }
      selectedButtonTabId={selectedTab}
    >
      <ButtonTab id="leads">
        {t('Referral_Requests', 'Referral Requests')}
      </ButtonTab>
      <ButtonTab id="all-referrals">
        {t('All_Referrals', 'All Referrals')}
      </ButtonTab>
    </ButtonTabs>
  );
};

export default TrackingTabs;
